module.exports = __webpack_public_path__ + "/images/ico-color-embarazada.c22193d.svg";